
    <button
      mat-raised-button
      color="accent"
      type="button"
      [disabled]="disabled"
      (click)="onClick()"
      class="with-loading full-width"
    >
      <mat-progress-spinner
        *ngIf="loading"
        class="spinner"
        mode="indeterminate"
        [diameter]="24"
        [strokeWidth]="3"
      >
      </mat-progress-spinner>
      <span *ngIf="!loading"> {{ name | translate | uppercase }} </span>
    </button>
  